import { BaseModel } from '../base.model';
import { JsonProperty } from '../json-map.util';
import { ExerciseModel } from '../exercise/exercise.model';
import { SolutionModel } from '../solution/solution.model';
import { PassageModel } from '../passage/passage.model';
import { TopicModel } from '../topic/topic.model';

class ProblemModel extends BaseModel {

  title: string = undefined as any;
  content: string = undefined as any;
  difficulty: number = undefined as any;
  displayName: string = undefined as any;
  explanation: string = undefined as any;

  @JsonProperty({ clazz: ExerciseModel })
  exercises: ExerciseModel[] = [];

  @JsonProperty({ clazz: PassageModel })
  passage: PassageModel = undefined as any;

  @JsonProperty({ clazz: SolutionModel })
  solutions: SolutionModel[] = [];

  @JsonProperty({ clazz: TopicModel })
  topic: TopicModel = undefined as any;

  parse(json: Object) {
    if (json) {
      super.parse(json);
    }

    return this;
  }
}

class ProblemOptionsModel extends BaseModel {

  id: number = undefined as any;
  title: string = undefined as any;
  content: string = undefined as any;
  answers: string[] = undefined as any;
  hint: string = undefined as any;
  solutionId: number = undefined as any;
  hasNext: boolean = undefined as any;
  isLatestProblem: boolean = undefined as any;

  @JsonProperty({ clazz: PassageModel })
  passage: PassageModel = undefined as any;
}

class ProblemPaginator {
  totalCount: number = undefined as any;
  problems: ProblemModel[] = [];
}


export { ProblemModel, ProblemOptionsModel, ProblemPaginator };
